	var header_height = $('header').height();
	if($('.header.white').length){
		var isWhite = true;
	}
	$(window).bind('scroll', function () {
		if(window.innerWidth > 930){
			if ($(window).scrollTop() > 200) {
				$('header').addClass('fixed');
				$('header').css('top', -header_height+"px");
				if(isWhite){
					$('.header').removeClass('white');
				}
				$('body').css('margin-top', header_height+'px');
			} else {
				$('header').removeClass('fixed');
				$('header').css('top', '');
				if(isWhite){
					$('.header').addClass('white');
				}
				$('body').css('margin-top', '');
			}
		} else {
			if ($(window).scrollTop() > 200) {
				$('header').addClass('fixed');
			} else {
				$('header').removeClass('fixed');
			}
		} 
	});